module.exports = "pegasus/assets/blocks/column-15-theme2.png";